import { useMediaQuery } from "@mui/material";
import { Tab, Tabs } from "@mui/material";
import { Box, Button, CircularProgress } from "@mui/material";
import { IconButton, Switch } from "@mui/material";
import { Typography } from "@mui/material";
import { TracksPageProps, filterAndSort } from "./types";
import { useCallback } from "react";
import { useContext, useEffect, useRef, useState } from "react";
import { FilterMenu } from "../../components/TracksPageComponents/FilterMenu";
import { SortMenu } from "../../components/TracksPageComponents/SortMenu";
import { AuthContext, UserDetailsContext } from "../../contexts";
import useGetValidAccessToken from "../../hooks/useGetValidAccessToken";
import { CustomTracksPageHeadingContainer } from "./styles";
import { CustomTracksListContainer } from "./styles";
import { CustomTracksScrollingContainer } from "./styles";
import { MobileScreenBottomNavigationContainer } from "./styles";
import { styles } from "./styles";
import { TrackListView } from "../../components/TracksPageComponents/TrackListView";
import {
  fetchCollaboratorsForUser,
  getModalMessage,
  handlePublish,
} from "./tracksHandler";
import { getTracks } from "./tracksHandler";
import { fetchArtistsForUser } from "./tracksHandler";
import { TrackVersionsObj } from "../MyTracks/types";
import { TrackFilterParams, TrackObj } from "../MyTracks/types";
import { FilterAndSortDetails } from "../../components/TracksPageComponents/FilterAndSortDetails";
import { TracksSearchBar } from "../../components/TracksPageComponents/TracksSearchBar";
import { AddMusicSection } from "../../components/TracksPageComponents/AddMusicSection";
import CloseIcon from "@mui/icons-material/Close";
import CreateNewFolderOutlinedIcon from "@mui/icons-material/CreateNewFolderOutlined";
import { AddMusicSectionStyles } from "../../components/TracksPageComponents/styles";
import { ControllersContainer } from "../../components/TracksPageComponents/styles";
import { TracksPageMainContainer } from "../../components/TracksPageComponents/styles";
import useInfiniteScroll from "../../hooks/useInfiniteScroll";
import { MobileScreenBottomNavigation } from "../../components/TracksPageComponents/MobileScreenBottomNavigation";
import { AddTrackVersionModal } from "../../components/Modal/AddTrackVersionModal";
import {
  FileState,
  Folder,
  GetFoldersResponse,
  LinkFoldersToProjectResponse,
  UpdateProjectFilesResponse,
} from "../../proto/api_pb";
import { ProjectFile, TrackState } from "../../proto/api_pb";
import { UpdateTrackPositionResponse } from "../../proto/api_pb";
import { SubscriptionTier, Track } from "../../proto/api_pb";
import CollabModal from "../../components/Modal/CollabModal";
import { TrackToPlay } from "../ExplorePage/types";
import { AudioDetails } from "../../components/TracksPageComponents/types";
import { AudioPlayer } from "../../components/TracksPageComponents/AudioPlayer";
import TrackAddModal from "../../components/Modal/TrackAddModal";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import BatchTrackAddModal from "../../components/Modal/BatchTrackModal";
import ConfirmationMessageModal from "../../components/Modal/ConfirmationMessageModal";
import { MobileDrawer } from "../../components/MobileDrawer/MobileDrawer";
import { UpdateTrackPosition } from "../../services/reorderService";
import { UpdateSubModal } from "../../components/Modal/UpdateSubModal";
import { SelectVersionDeleteModal } from "../../components/Modal/SelectVersionDeleteModal";
import { a11yProps } from "../../components/TracksPageComponents/CustomTabPanel";
import { CustomTabPanel } from "../../components/TracksPageComponents/CustomTabPanel";
import { FilesSection } from "../../components/TracksPageComponents/FilesSection";
import { AddItemsModal } from "../../components/Modal/AddItemsModal";
import { splitSheetStyles } from "../../components/Modal/styles";
import { SubscriptionInfoModal } from "../../components/Modal/SubscriptionInfoModal";
import PostAddIcon from "@mui/icons-material/PostAdd";
import {
  linkFolderToProjectOrFolder,
  updateProjectFiles,
} from "../../services/projectService";
import { toast } from "react-toastify";
import { projectPageStyles } from "../Projects/styles";
import { ProjectFileFilterMenu } from "../Projects/ProjectFileFilterMenu";
import { ProjectFileSearchBar } from "../../components/SingleProject/ProjectFileSearchbar";
import { ProjectFilesSortMenu } from "../../components/SingleProject/ProjectFilesSortMenu";
import { FileStateReverseMap } from "../../components/SingleProject/types";
import DeleteConfirmationModal from "../../components/Modal/DeleteConfirmationModal";
import CustomButton from "../../components/CustomButton/CustomButton";
import AddFolderModal from "../../components/Modal/AddFolderModal";
import { getAllFolders } from "../../services/folderService";
import { TracksTableHeadings } from "../../components/TracksPageComponents/TracksTableHeadings";
import { FolderSection } from "../../components/TracksPageComponents/FolderSection";
import { Breadcrumbs } from "../../components/BreadCrumbs/BreadCrumbs";
const label = { inputProps: { "aria-label": "Checkbox demo" } };

export const TracksPage: React.FC<TracksPageProps> = ({
  setUploadingFilesDetailsList,
  setIsUploading,
  setUploadingCardsStatusList,
  session,
  setInbox,
  setIsUploadProcessing,
  openFoldersList,
  setOpenFoldersList,
  setFolderUploadInfo,
}) => {
  const [tracks, setTracks] = useState<TrackObj[]>([]);
  const [selectedTrackLatestVersion, setSelectedTrackLatestVersion] =
    useState(0);
  const [allArtistList, setAllArtistList] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [checkedTracks, setCheckedTracks] = useState<TrackObj[]>([]);
  const [checkedFiles, setCheckedFiles] = useState<ProjectFile[]>([]);
  const [isTracksPublic, setIsTracksPublic] = useState(false);
  const [isAllTracksSelected, setIsAllTracksSelected] = useState(false);
  const [isAllFilesSelected, setIsAllFilesSelected] = useState(false);
  const [openCollabsModal, setOpenCollabsModal] = useState(false);
  const [isSingleTrackModalOpen, setIsSingleTrackModalOpen] = useState(false);
  const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
  const [isUpdateSubModalOpen, setIsUpdateSubModalOpen] = useState(false);
  const [isBatchTrackModalOpen, setIsBatchTrackModalOpen] = useState(false);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [isSelectDeleteModalOpen, setIsSelectDeleteModalOpen] = useState(false);
  const [isPlayButtonClicked, setIsPlayButtonClicked] =
    useState<boolean>(false);
  const [trackToPlay, setTrackToPlay] = useState<TrackToPlay>();
  const [isTrackForPlay, setIsTrackForPlay] = useState<boolean>(true);
  const [versionToPlay, setVersionToPlay] = useState<TrackVersionsObj>();
  const [audioDetails, setAudioDetails] = useState<AudioDetails>();
  const [filterAndSortChanged, setFilterAndSortChanged] =
    useState<boolean>(false);
  const [filterAndSortParams, setFilterAndSortParams] =
    useState<TrackFilterParams>(filterAndSort);
  const [isReorderAvailable, setIsReorderAvailable] = useState<boolean>(
    filterAndSortParams.sortBy === "Custom Order"
  );
  const [collaboratorsOptionsList, setCollaboratorsOptionsList] = useState<
    string[]
  >([]);
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const [selectedTrack, setSelectedTrack] = useState<Track>();
  const [selectedTrackUrl, setSelectedTrackUrl] = useState("");
  const [versionModalIsOpen, setVersionModalIsOpen] = useState(false);
  const [draggedTrackIndex, setDraggedTrackIndex] = useState<number | null>(
    null
  );
  const [draggedIndex, setDraggedIndex] = useState<null | number>(null);
  const [queryValue, setQueryValue] = useState<string>("");
  const [projectQueryValue, setProjectQueryValue] = useState<string>("");
  const [value, setValue] = useState(0);
  const [trackToExpand, setTrackToExpand] = useState("");
  const [isProcessing, setIsProcessing] = useState<boolean>(false);
  const loadingRef = useRef<HTMLDivElement | null>(null);
  const { userId } = useContext(AuthContext);
  const [filter, setFilter] = useState<string>("");
  const [filesSortBy, setFilesSortBy] = useState<0 | 1 | 2>(1);
  const [initialLand, setInitialLand] = useState(false);
  const [folders, setFolders] = useState<Folder[]>([]);
  const [filesSortingIsAscending, setFilesSortingIsAscending] = useState(false);
  const [selectedFolders, setSelectedFolders] = useState<string[]>([]);
  const { getValidAccessToken } = useGetValidAccessToken();
  const { subscriptionTier, isEnterpriseAccount, enterprise, role } =
    useContext(UserDetailsContext);
  const isMediumScreen = useMediaQuery("(max-width: 1336px)");
  const [isAddFolderToProject, setIsAddFolderToProject] =
    useState<boolean>(false);
  const {
    page,
    scrollContainerRef,
    setIsScrollEnabled,
    isScrollEnabled,
    setPage,
  } = useInfiniteScroll();
  const ref = useRef<HTMLDivElement | null>(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { projectId, projectName, folderIdFromNavigation } =
    location.state || {};
  const { name, id, folderId } = useParams();
  const isAddToProjectPage =
    (window.location.pathname.includes("my-tracks") &&
      folderIdFromNavigation) ||
    projectId;
  const isHubPage = window.location.pathname.includes("my-tracks");

  const handleChange = async (
    event: React.SyntheticEvent,
    newValue: number
  ) => {
    setIsAllTracksSelected(false);
    setIsAllFilesSelected(false);
    if (!isAddToProjectPage) setCheckedTracks([]);
    if (!isAddToProjectPage) setCheckedFiles([]);
    setFilterAndSortParams(filterAndSort);
    setQueryValue("");
    setValue(newValue);
    setTracks([]);
    setIsLoading(true);

    const token = await getValidAccessToken();
    await getTracks(
      userId,
      filterAndSort,
      token,
      setTracks,
      0,
      setIsScrollEnabled,
      "",
      setIsLoading,
      !isHubPage ? id : undefined,
      isEnterpriseAccount ? enterprise?.id : undefined,
      isEnterpriseAccount ? Number(role) : undefined,
      newValue === 2 ? true : false,
      folderId
    );

    sessionStorage.setItem("TabValue", JSON.stringify(newValue));
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const plan = params.get("plan");
    setInitialLand(plan === "trial-major");
    const previousTabValue = sessionStorage.getItem("TabValue")
      ? JSON.parse(sessionStorage.getItem("TabValue")!)
      : null;
    if (previousTabValue !== null) {
      if (previousTabValue === 0) {
        setValue(0);
      } else if (previousTabValue === 1) {
        setValue(1);
      } else if (previousTabValue === 2) {
        setValue(0);
      }
    }
  }, []);

  const handleClosePlayerForModal = () => {
    setIsPlayButtonClicked(false);
    setIsTrackForPlay(false);
    setTrackToPlay(undefined);
  };
  const isBoxChecked = (item: TrackObj): boolean => {
    return (
      checkedTracks.findIndex(
        (t) => t.track?.getId() === item.track?.getId()
      ) !== -1
    );
  };

  const isFileChecked = (item: ProjectFile): boolean => {
    return checkedFiles.findIndex((t) => t.getId() === item.getId()) !== -1;
  };
  const handleExpandTrack = (trackId: string) => {
    setTrackToExpand((prevId) => (prevId === trackId ? "" : trackId));
  };

  const handleRefreshTracks = async () => {
    setIsLoading(true);
    setPage(0);
    setTracks([]);
    const token = await getValidAccessToken();
    await getTracks(
      userId,
      filterAndSort,
      token,
      setTracks,
      0,
      setIsScrollEnabled,
      "",
      setIsLoading,
      !isHubPage ? id : undefined,
      isEnterpriseAccount ? enterprise?.id : undefined,
      isEnterpriseAccount ? Number(role) : undefined,
      value === 2 ? true : false,
      folderId
    );
    setIsLoading(false);
  };

  const handleCloseCollabsModal = () => {
    setOpenCollabsModal(false);
    clearSelectedTrack();
  };

  const handleOpenMessageModal = () => {
    setIsMessageModalOpen(true);
  };

  const handleOpenCollabsModal = (tr: TrackObj) => {
    // setEvokeCallBack((prev) => prev + 1);

    handleClosePlayerForModal();
    setOpenCollabsModal(true);
    setSelectedTrack(tr.track);
  };
  const handleOpenSelectDeleteModal = (tr: TrackObj) => {
    handleClosePlayerForModal();
    setIsSelectDeleteModalOpen(true);
    setSelectedTrack(tr.track);
  };
  const handleOpenEditTrackModal = (tr: TrackObj) => {
    handleClosePlayerForModal();
    setIsSingleTrackModalOpen(true);
    setSelectedTrack(tr.track);
    setSelectedTrackUrl(tr.trackUrl);
  };

  const handleOpenUpdateSubModal = () => {
    if (isEnterpriseAccount) return;
    handleClosePlayerForModal();
    setIsUpdateSubModalOpen(true);
  };

  const handleCloseUpdateSubModal = () => {
    setIsUpdateSubModalOpen(false);
  };

  const handleCloseInfoSubModal = () => {
    setInitialLand(false);
  };

  const handleAscendingOrDescending = () => {
    setPage(0);
    setTracks([]);
    setFilterAndSortParams((prev) => {
      return {
        ...prev,
        isAscending: !filterAndSortParams.isAscending,
      };
    });
  };

  useEffect(() => {
    const handleUseEffect = async () => {
      const token = await getValidAccessToken();
      fetchArtistsForUser(token, userId, setAllArtistList);
      fetchCollaboratorsForUser(token, userId, setCollaboratorsOptionsList);
    };
    handleUseEffect();
  }, [getValidAccessToken, userId]);

  const handleFetchTracks = useCallback(async () => {
    if (!filterAndSortChanged && queryValue === "" && userId) {
      setIsLoading(true);
      const token = await getValidAccessToken();
      await getTracks(
        userId,
        filterAndSort,
        token,
        setTracks,
        page,
        setIsScrollEnabled,
        "",
        setIsLoading,
        !isHubPage ? id : undefined,
        isEnterpriseAccount ? enterprise?.id : undefined,
        isEnterpriseAccount ? Number(role) : undefined,
        value === 2 ? true : false,
        folderId
      );
    }
  }, [
    enterprise?.id,
    filterAndSortChanged,
    folderId,
    getValidAccessToken,
    id,
    isEnterpriseAccount,
    isHubPage,
    page,
    queryValue,
    role,
    setIsScrollEnabled,
    userId,
    value,
  ]);

  const handleApplyFilterAndSort = useCallback(async () => {
    if (
      filterAndSortParams.isAscending === false &&
      filterAndSortParams.genreList.length === 0 &&
      filterAndSortParams.artistList.length === 0 &&
      filterAndSortParams.collaboratorsList.length === 0 &&
      filterAndSortParams.TrackPrivacy === "All" &&
      filterAndSortParams.bpmStartValue === 0 &&
      filterAndSortParams.bpmEndValue === 200 &&
      filterAndSortParams.sortBy === "Notifications" &&
      filterAndSortParams.status === ""
    ) {
      return;
    } else {
      if (filterAndSortChanged) {
        setIsLoading(true);
        const token = await getValidAccessToken();
        await getTracks(
          userId,
          filterAndSortParams,
          token,
          setTracks,
          page,
          setIsScrollEnabled,
          queryValue,
          setIsLoading,
          id === "undefined" ? "" : id ?? "",
          isEnterpriseAccount ? enterprise?.id : undefined,
          isEnterpriseAccount ? Number(role) : undefined,
          value === 2 ? true : false,
          folderId
        );
      }
    }
  }, [
    enterprise?.id,
    filterAndSortChanged,
    filterAndSortParams,
    folderId,
    getValidAccessToken,
    id,
    isEnterpriseAccount,
    page,
    queryValue,
    role,
    setIsScrollEnabled,
    userId,
    value,
  ]);

  useEffect(() => {
    if (filterAndSortChanged) {
      handleApplyFilterAndSort();
    }
  }, [filterAndSortChanged, handleApplyFilterAndSort]);

  const clearSelectedTrack = () => {
    setSelectedTrack(undefined);
    setSelectedTrackUrl("");
  };

  const handleOpenTrackVersionModal = (
    tr: Track,
    latestVersionNumber: number
  ) => {
    if (
      subscriptionTier === SubscriptionTier.SUBSCRIPTION_TIER_FREE &&
      !isEnterpriseAccount
    ) {
      setIsUpdateSubModalOpen(true);
    } else {
      handleClosePlayerForModal();
      setSelectedTrackLatestVersion(latestVersionNumber);
      setSelectedTrack(tr);
      setVersionModalIsOpen(true);
    }
  };

  const handleCloseTrackVersionModal = () => {
    setVersionModalIsOpen(false);
    clearSelectedTrack();
  };

  const handleCloseTrackAddModal = () => {
    setIsSingleTrackModalOpen(false);
    clearSelectedTrack();
  };
  const handleCloseBatchTrackAddModal = () => {
    setIsBatchTrackModalOpen(false);
    clearSelectedTrack();
  };

  const handleOpenBatchTrackAddModal = () => {
    handleClosePlayerForModal();
    setIsBatchTrackModalOpen(true);
  };

  useEffect(() => {
    handleFetchTracks();
  }, [handleFetchTracks]);

  const handleCheckedTrackChange = (track: TrackObj, id: string) => {
    setCheckedTracks((prevTracks) => {
      const trackIndex = prevTracks.findIndex((t) => t.track?.getId() === id);
      if (trackIndex === -1) {
        return [...prevTracks, track];
      } else {
        const updatedTracks = [...prevTracks];
        updatedTracks.splice(trackIndex, 1);
        return updatedTracks;
      }
    });
  };

  const handleCheckedFileChange = (file: ProjectFile, id: string) => {
    setCheckedFiles((prevFiles) => {
      const fileIndex = prevFiles.findIndex((t) => t.getId() === id);
      if (fileIndex === -1) {
        return [...prevFiles, file];
      } else {
        const updatedFiles = [...prevFiles];
        updatedFiles.splice(fileIndex, 1);
        return updatedFiles;
      }
    });
  };

  const handleDragStart = (index: number) => {
    setDraggedTrackIndex(index);
  };

  const handleDrop = async () => {
    if (isReorderAvailable) {
      if (draggedTrackIndex === null || draggedIndex === null) return;
      const updatedTracks = [...tracks];
      const [draggedTrack] = updatedTracks.splice(draggedTrackIndex, 1);
      updatedTracks.splice(draggedIndex, 0, draggedTrack);
      setTracks([]);
      setDraggedTrackIndex(null);
      const trackId = tracks[draggedTrackIndex].track?.getId();
      const token = await getValidAccessToken();
      setTracks(updatedTracks);
      if (trackId) {
        const response = await UpdateTrackPosition(
          token,
          userId,
          trackId,
          draggedIndex,
          isEnterpriseAccount ? enterprise?.id : undefined
        );
        if (response instanceof UpdateTrackPositionResponse) {
          console.log("updated tracks position");
        }
      }
    }
  };

  useEffect(() => {
    if (filterAndSortParams.sortBy === "Custom Order") {
      setPage(0);
      setTracks([]);
      setIsReorderAvailable(true);
    } else {
      setPage(0);
      setTracks([]);
      setIsReorderAvailable(false);
    }
  }, [filterAndSortParams.sortBy, setPage]);

  useEffect(() => {
    const allPublished = checkedTracks.filter(
      (checkedTrack) =>
        checkedTrack.track?.getState() === TrackState.TRACK_STATE_PUBLISHED
    );
    const isPublished =
      allPublished.length === checkedTracks.length ? true : false;
    setIsTracksPublic(isPublished);
  }, [checkedTracks]);

  const handleLinkFilesToProject = async () => {
    if (projectId && (checkedFiles.length > 0 || checkedTracks.length > 0)) {
      setIsProcessing(true);
      const token = await getValidAccessToken();
      checkedFiles.forEach((file) => {
        file.setProjectId(projectId);
        if (!file.getParentFolderIdList().includes(`root@${projectId}`)) {
          file.setParentFolderIdList([
            ...file.getParentFolderIdList(),
            `root@${projectId}`,
          ]);
        }
      });
      const tracksToUpdate = checkedTracks
        .map((track) => track.track)
        .filter((track): track is Track => track !== undefined);
      tracksToUpdate.forEach((track) => {
        track.setProjectId(projectId);
        if (!track.getParentFolderIdList().includes(`root@${projectId}`)) {
          track.setParentFolderIdList([
            ...track.getParentFolderIdList(),
            `root@${projectId}`,
          ]);
        }
      });
      const res = await updateProjectFiles(token, checkedFiles, tracksToUpdate);
      if (res instanceof UpdateProjectFilesResponse) {
        if (value === 0 || value === 2) {
          toast.info("Tracks Added To Project");
        } else {
          toast.info("Files Added To Project");
        }
        setCheckedFiles([]);
        navigate(`/project/${encodeURIComponent(projectName)}/${projectId}`);
      }
      setIsProcessing(false);
    } else {
      toast.info("No tracks or files selected");
    }
  };

  const handleLinkFoldersToProject = async () => {
    if (projectId && selectedFolders.length > 0) {
      setIsProcessing(true);
      const token = await getValidAccessToken();
      const res = await linkFolderToProjectOrFolder(
        token,
        projectId,
        selectedFolders,
        folderIdFromNavigation,
        userId,
        enterprise?.id ?? ""
      );
      if (res instanceof LinkFoldersToProjectResponse) {
        toast.info("Folders Added To Project");
        setSelectedFolders([]);
        setIsProcessing(false);
        if (folderIdFromNavigation) {
          navigate(
            `/project/${encodeURIComponent(
              projectName
            )}/${projectId}/folder/${folderIdFromNavigation}`
          );
        } else {
          navigate(`/project/${encodeURIComponent(projectName)}/${projectId}`);
        }
      }
    } else {
      toast.info("No folders selected");
    }
  };

  const handleLinkFilesToFolder = async () => {
    if (
      folderIdFromNavigation &&
      (checkedFiles.length > 0 || checkedTracks.length > 0)
    ) {
      setIsProcessing(true);
      const token = await getValidAccessToken();
      checkedFiles.forEach((file) => {
        if (!file.getParentFolderIdList().includes(folderIdFromNavigation)) {
          file.setParentFolderIdList([
            ...file.getParentFolderIdList(),
            folderIdFromNavigation,
          ]);
        }
        if (projectId !== "undefined" && projectId !== "")
          file.setProjectId(projectId);
      });
      const tracksToUpdate = checkedTracks
        .map((track) => track.track)
        .filter((track): track is Track => track !== undefined);
      tracksToUpdate.forEach((track) => {
        if (!track.getParentFolderIdList().includes(folderIdFromNavigation)) {
          track.setParentFolderIdList([
            ...track.getParentFolderIdList(),
            folderIdFromNavigation,
          ]);
        }
        if (projectId !== "undefined" && projectId !== "")
          track.setProjectId(projectId);
      });
      const res = await updateProjectFiles(token, checkedFiles, tracksToUpdate);
      if (res instanceof UpdateProjectFilesResponse) {
        if (value === 0 || value === 2) {
          toast.info("Tracks Added To Folder");
        } else {
          toast.info("Files Added To Folder");
        }
        setCheckedFiles([]);
        navigate(
          `/project/${encodeURIComponent(
            projectName
          )}/${projectId}/folder/${folderIdFromNavigation}`
        );
      }
      setIsProcessing(false);
    } else {
      toast.info("No tracks or files selected");
    }
  };

  useEffect(() => {
    if (!isSmallScreen) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isSmallScreen]);

  const handleRemoveOrDeleteFiles = async () => {
    const token = await getValidAccessToken();
    const allTracks: Track[] = checkedTracks
      .map((checkedTrack) => checkedTrack.track)
      .filter((track): track is Track => track !== undefined);
    if (isHubPage || id === "undefined") {
      allTracks.forEach((element) => {
        element.setState(TrackState.TRACK_STATE_DELETED);
      });
      if (allTracks.length > 0) {
        toast.info("Track successfully deleted");
      }
    } else {
      allTracks.forEach((element) => {
        element.setProjectId("");
        const updatedFolderIds = element
          .getParentFolderIdList()
          .filter((id) => id !== folderId && id !== `root@${id}`);
        element.setParentFolderIdList(updatedFolderIds);
      });
      if (allTracks.length > 0) {
        toast.info("Track successfully removed");
      }
    }
    if (checkedFiles.length > 0) {
      if (isHubPage) {
        toast.info("File successfully deleted");
      } else {
        toast.info("File successfully removed");
      }
    }
    checkedFiles.forEach((file) => {
      file.setProjectId("");
      const updatedFolderIds = file
        .getParentFolderIdList()
        .filter((id) => id !== folderId && id !== `root@${id}`);
      file.setParentFolderIdList(updatedFolderIds);
      if (isHubPage) {
        file.setFileState(FileStateReverseMap[FileState.FILE_STATE_DELETED]);
      }
    });
    const totalFiles = checkedFiles.length > 0 ? checkedFiles : [];
    const totalTracks = allTracks.length > 0 ? allTracks : [];
    const res = await updateProjectFiles(token, totalFiles, totalTracks);
    if (res instanceof UpdateProjectFilesResponse) {
      setIsConfirmationModalOpen(false);
      navigate(0);
    }
  };

  const getAllFoldersForProject = useCallback(async () => {
    if (!enterprise || !enterprise.id) return;
    const token = await getValidAccessToken();
    const res = await getAllFolders(
      token,
      userId,
      id === "undefined" ? "" : id ?? "",
      folderId,
      enterprise.id,
      isHubPage
    );
    if (res instanceof GetFoldersResponse) {
      setFolders(res.getFoldersList());
    }
  }, [enterprise, getValidAccessToken, userId, id, folderId, isHubPage]);

  useEffect(() => {
    if (isEnterpriseAccount && userId) {
      getAllFoldersForProject();
    }
  }, [getAllFoldersForProject, isEnterpriseAccount, userId]);

  useEffect(() => {
    const handleBackButton = () => {
      if (openFoldersList && openFoldersList.length > 0) {
        const updatedFolders = [...openFoldersList];
        updatedFolders.pop();
        setOpenFoldersList?.(updatedFolders);
        setTracks([]);
        localStorage.setItem("breadcrumbs", JSON.stringify(updatedFolders));
      }
    };

    window.addEventListener("popstate", handleBackButton);
    return () => window.removeEventListener("popstate", handleBackButton);
  }, [openFoldersList, setOpenFoldersList]);

  return (
    <>
      <MobileDrawer />
      {(checkedTracks.length > 0 || checkedFiles.length > 0) && (
        <DeleteConfirmationModal
          isMessageModalOpen={isConfirmationModalOpen}
          message={getModalMessage(checkedTracks, checkedFiles)}
          toggle={() => setIsConfirmationModalOpen((prev) => !prev)}
          handleConfirm={handleRemoveOrDeleteFiles}
        />
      )}
      {isMessageModalOpen && (
        <ConfirmationMessageModal
          isMessageModalOpen={isMessageModalOpen}
          message="Your tracks are being processed, you will receive an email when they are done processing."
          toggle={() => setIsMessageModalOpen((prev) => !prev)}
        />
      )}
      {isSelectDeleteModalOpen && (
        <SelectVersionDeleteModal
          isModalOpen={isSelectDeleteModalOpen}
          handleCloseModal={() => setIsSelectDeleteModalOpen(false)}
          selectedTrack={selectedTrack}
          handleRefreshTracks={handleRefreshTracks}
        />
      )}
      {isSingleTrackModalOpen && (
        <TrackAddModal
          trackToEdit={selectedTrack}
          trackToEditUrl={selectedTrackUrl}
          isModalOpen={isSingleTrackModalOpen}
          handleCloseTrackAddModal={handleCloseTrackAddModal}
          handleRefreshTracks={handleRefreshTracks}
        />
      )}
      {initialLand && !isEnterpriseAccount && (
        <SubscriptionInfoModal
          open={initialLand}
          handleCloseModal={handleCloseInfoSubModal}
        />
      )}
      {isUpdateSubModalOpen && (
        <UpdateSubModal
          open={isUpdateSubModalOpen}
          handleCloseModal={handleCloseUpdateSubModal}
        />
      )}
      {isBatchTrackModalOpen && (
        <BatchTrackAddModal
          isModalOpen={isBatchTrackModalOpen}
          handleCloseBatchTrackAddModal={handleCloseBatchTrackAddModal}
          setIsUploading={setIsUploading}
          setUploadingFilesDetailsList={setUploadingFilesDetailsList}
          setUploadingCardsStatusList={setUploadingCardsStatusList}
          handleOpenMessageModal={handleOpenMessageModal}
          setIsUploadProcessing={setIsUploadProcessing}
          setFolderUploadInfo={setFolderUploadInfo}
        />
      )}
      {openCollabsModal && (
        <CollabModal
          openCollabsModal={openCollabsModal}
          handleCloseCollabsModal={handleCloseCollabsModal}
          trackToEdit={selectedTrack}
          handleFetchTrackFiles={handleRefreshTracks}
        />
      )}
      {versionModalIsOpen && (
        <AddTrackVersionModal
          open={versionModalIsOpen}
          handleTrackMenuClose={() => {}}
          handleCloseModal={handleCloseTrackVersionModal}
          track={selectedTrack}
          handleRefreshTracks={handleRefreshTracks}
          selectedTrackLatestVersion={selectedTrackLatestVersion}
        />
      )}
      <Box
        ref={isSmallScreen ? scrollContainerRef : null}
        sx={
          isSmallScreen
            ? styles.mainScrollC
            : {
                display: "flex",
                backgroundColor: projectId ? "#10222e" : "",
              }
        }
      >
        <TracksPageMainContainer>
          <Box
            sx={{
              height: "95%",
              width: isSmallScreen
                ? "90vw"
                : isMediumScreen
                ? "74vw"
                : "calc(100vw - 365px)",
            }}
          >
            <CustomTracksPageHeadingContainer>
              <Breadcrumbs
                setOpenFoldersList={setOpenFoldersList}
                openFoldersList={openFoldersList}
                handleRefreshTracks={handleRefreshTracks}
                setTracks={setTracks}
                folders={folders}
              />
              <Box sx={AddMusicSectionStyles.buttonBox}>
                {!isHubPage && (
                  <>
                    <CustomButton
                      icon={PostAddIcon}
                      text={`Add Tracks & Files to ${
                        folderId ? "folder" : "project"
                      }`}
                      onClick={() => {
                        setIsAddFolderToProject(false);
                        navigate("/my-tracks", {
                          state: {
                            projectId: id,
                            projectName: name,
                            folderIdFromNavigation: folderId,
                          },
                        });
                      }}
                    />
                    {(!window.location.pathname.includes("untitled") ||
                      !window.location.pathname.includes("undefined")) && (
                      <CustomButton
                        icon={CreateNewFolderOutlinedIcon}
                        text="Add Folders"
                        onClick={() => {
                          setIsAddFolderToProject(true);
                          navigate("/my-tracks", {
                            state: {
                              projectId: id,
                              projectName: name,
                              folderIdFromNavigation: folderId,
                            },
                          });
                        }}
                      />
                    )}
                  </>
                )}
                {isHubPage && (
                  <CustomButton
                    onClick={() => navigate("/share-management")}
                    text="Shared Tracks"
                  />
                )}
                {(isHubPage ||
                  window.location.pathname.includes("untitled") ||
                  window.location.pathname.includes("undefined")) && (
                  <AddFolderModal
                    projectId={id ?? ""}
                    refreshFolders={getAllFoldersForProject}
                    folderId={folderId}
                  />
                )}
                {isHubPage && (
                  <AddMusicSection
                    handleOpenBatchTrackAddModal={handleOpenBatchTrackAddModal}
                    handleOpenUpdateSubModal={handleOpenUpdateSubModal}
                  />
                )}
                {isEnterpriseAccount && isHubPage && (
                  <AddItemsModal
                    setUploadingFilesDetailsList={setUploadingFilesDetailsList}
                    setIsUploading={setIsUploading}
                    setUploadingCardsStatusList={setUploadingCardsStatusList}
                    setIsUploadProcessing={setIsUploadProcessing}
                    setFolderUploadInfo={setFolderUploadInfo}
                    getAllFoldersForProject={getAllFoldersForProject}
                  />
                )}
              </Box>
            </CustomTracksPageHeadingContainer>
            <Box sx={projectPageStyles.filterContainerBox}>
              {!projectId && value === 1 && (
                <Box sx={projectPageStyles.filterContainer}>
                  <Box sx={{ margin: "9px 0px" }}>
                    <ProjectFileSearchBar
                      queryValue={projectQueryValue}
                      setQueryValue={setProjectQueryValue}
                    />
                    <ProjectFileFilterMenu
                      filter={filter}
                      setFilter={setFilter}
                    />
                    <ProjectFilesSortMenu
                      filesSortBy={filesSortBy}
                      setFilesSortBy={setFilesSortBy}
                    />
                  </Box>
                  <Box sx={styles.fileCountContainer}>
                    {checkedFiles.length > 0 && (
                      <Box sx={styles.checkedFilesDetailsContainer}>
                        {checkedFiles.length} Files Selected
                      </Box>
                    )}
                    {checkedFiles.length > 0 && (
                      <Button
                        sx={projectPageStyles.deleteRemoveButton}
                        onClick={(e) => {
                          e.stopPropagation();
                          setIsConfirmationModalOpen(true);
                        }}
                      >
                        {isHubPage ? "Delete " : "Remove "}
                        {value === 1 ? "Files" : "Tracks"}
                      </Button>
                    )}
                  </Box>
                </Box>
              )}
              {!projectId && (
                <ControllersContainer
                  sx={{
                    display: value === 0 || value === 2 ? "flex" : "none",
                    ...styles.controllersContainer,
                  }}
                >
                  <Box
                    sx={{
                      ...styles.filtersContainer,
                      gap: isSmallScreen ? "10px" : "",
                    }}
                  >
                    <TracksSearchBar
                      setTracks={setTracks}
                      setPage={setPage}
                      queryValue={queryValue}
                      setQueryValue={setQueryValue}
                      setFilterAndSortChanged={setFilterAndSortChanged}
                    />
                    <Box sx={{ display: "flex", gap: "10px" }}>
                      <FilterMenu
                        allArtistList={allArtistList}
                        collaboratorsOptionsList={collaboratorsOptionsList}
                        filterAndSortParams={filterAndSortParams}
                        setFilterAndSortParams={setFilterAndSortParams}
                        handleFiltersAndSort={handleApplyFilterAndSort}
                        setPage={setPage}
                        setTracks={setTracks}
                        value={value}
                      />
                      <SortMenu
                        setFilterAndSortParams={setFilterAndSortParams}
                        filterAndSortParams={filterAndSortParams}
                        setPage={setPage}
                        setTracks={setTracks}
                        setFilterAndSortChanged={setFilterAndSortChanged}
                        handleRefreshTracks={handleRefreshTracks}
                      />
                    </Box>
                    {isHubPage && value === 0 && (
                      <Box sx={styles.reorderContainer}>
                        <Switch
                          {...label}
                          checked={isReorderAvailable}
                          onChange={() => {
                            setIsReorderAvailable(!isReorderAvailable);
                            if (!isReorderAvailable) {
                              setFilterAndSortChanged(true);
                              setPage(0);
                              setTracks([]);
                              setFilterAndSortParams((prev) => {
                                return {
                                  ...prev,
                                  sortBy: "Custom Order",
                                };
                              });
                            } else {
                              setPage(0);
                              setTracks([]);
                              setFilterAndSortParams((prev) => {
                                return {
                                  ...prev,
                                  sortBy: "Last modified",
                                };
                              });
                            }
                          }}
                        />
                        Custom Order
                      </Box>
                    )}
                  </Box>
                  <Box sx={styles.tracksCountSwitchContainer}>
                    {checkedTracks.length > 0 && (
                      <Box sx={styles.checkedTracksDetailsContainer}>
                        <Box sx={styles.checkTrackDetailsSwitchContainer}>
                          <Typography sx={{ fontSize: "14px" }}>
                            {checkedTracks.length} selected
                          </Typography>
                          <Switch
                            checked={isTracksPublic}
                            onChange={async () => {
                              setIsTracksPublic(!isTracksPublic);
                              const token = await getValidAccessToken();
                              await handlePublish(
                                checkedTracks,
                                token,
                                tracks,
                                userId,
                                isTracksPublic
                              );
                              setCheckedTracks([]);
                              await getTracks(
                                userId,
                                filterAndSortParams,
                                token,
                                setTracks,
                                page,
                                setIsScrollEnabled
                              );
                              setIsTracksPublic(false);
                            }}
                            {...label}
                          />
                          <Typography sx={{ fontSize: "14px" }}>
                            Make Public
                          </Typography>
                          <IconButton
                            onClick={() => {
                              setCheckedTracks([]);
                              setIsAllTracksSelected(false);
                            }}
                            sx={{ margin: "5px" }}
                          >
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        </Box>
                      </Box>
                    )}
                    {checkedTracks.length > 0 && (
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Button
                          sx={projectPageStyles.deleteRemoveButton}
                          onClick={(e) => {
                            e.stopPropagation();
                            setIsConfirmationModalOpen(true);
                          }}
                        >
                          {isHubPage ? "Delete " : "Remove "}
                          {value === 1 ? "Files" : "Tracks"}
                        </Button>
                      </Box>
                    )}
                  </Box>
                </ControllersContainer>
              )}
              {projectId && (
                <Box sx={styles.linkNotifyContainer}>
                  {value === 0 || value === 2 ? (
                    <>
                      <TracksSearchBar
                        setTracks={setTracks}
                        setPage={setPage}
                        queryValue={queryValue}
                        setQueryValue={setQueryValue}
                        setFilterAndSortChanged={setFilterAndSortChanged}
                      />
                      <Box
                        sx={{
                          // display: "flex",
                          display: projectId ? "none" : "flex",
                          gap: "10px",
                        }}
                      >
                        <FilterMenu
                          allArtistList={allArtistList}
                          collaboratorsOptionsList={collaboratorsOptionsList}
                          filterAndSortParams={filterAndSortParams}
                          setFilterAndSortParams={setFilterAndSortParams}
                          handleFiltersAndSort={handleApplyFilterAndSort}
                          setPage={setPage}
                          setTracks={setTracks}
                          value={value}
                        />
                        <SortMenu
                          setFilterAndSortParams={setFilterAndSortParams}
                          filterAndSortParams={filterAndSortParams}
                          setPage={setPage}
                          setTracks={setTracks}
                          setFilterAndSortChanged={setFilterAndSortChanged}
                          handleRefreshTracks={handleRefreshTracks}
                        />
                      </Box>
                    </>
                  ) : (
                    <ProjectFileSearchBar
                      queryValue={projectQueryValue}
                      setQueryValue={setProjectQueryValue}
                    />
                  )}

                  <Box
                    sx={
                      isSmallScreen
                        ? { width: "100%" }
                        : styles.linkNotifyIconContainer
                    }
                  >
                    <IconButton sx={{}}>
                      <PostAddIcon />
                    </IconButton>
                    <Typography>
                      Select the{" "}
                      {isAddFolderToProject
                        ? "folders"
                        : `${value !== 1 ? "tracks" : "files"}`}{" "}
                      you want to add to the {projectName}
                    </Typography>
                  </Box>
                  <Box
                    sx={
                      isSmallScreen
                        ? { width: "100%" }
                        : styles.linkButtonsContainer
                    }
                  >
                    <Button
                      onClick={() => {
                        value === 2 ? setValue(2) : setValue(0);
                        setIsAddFolderToProject(false);
                        setSelectedFolders([]);
                        setCheckedFiles([]);
                        setCheckedTracks([]);
                        setTracks([]);
                        folderIdFromNavigation
                          ? navigate(
                              `/project/${encodeURIComponent(
                                projectName
                              )}/${projectId}/folder/${folderIdFromNavigation}`
                            )
                          : navigate(
                              `/project/${encodeURIComponent(
                                projectName
                              )}/${projectId}`
                            );
                      }}
                      sx={{
                        ...styles.filterButton,
                        height: "40px",
                      }}
                    >
                      Back to {folderIdFromNavigation ? "folder" : "project"}
                    </Button>
                    {selectedFolders.length === 0 && !isAddFolderToProject && (
                      <Button
                        onClick={() => {
                          setCheckedTracks([]);
                          if (value === 1) setValue(0);
                          folderIdFromNavigation
                            ? handleLinkFilesToFolder()
                            : handleLinkFilesToProject();
                        }}
                        disabled={
                          checkedTracks.length === 0 &&
                          checkedFiles.length === 0
                        }
                        sx={{
                          ...styles.button,
                          ...{
                            height: "40px",
                            fontSize: "15px",
                            width: "150px",
                          },
                        }}
                      >
                        {isProcessing ? (
                          <CircularProgress sx={{ color: "black" }} size={25} />
                        ) : (
                          `Add selected ${
                            value === 0 || value === 2 ? "tracks" : "files"
                          }`
                        )}
                      </Button>
                    )}
                    {isEnterpriseAccount && isAddFolderToProject && (
                      <Button
                        onClick={() => {
                          setIsAddFolderToProject(false);
                          setSelectedFolders([]);
                          handleLinkFoldersToProject();
                        }}
                        disabled={selectedFolders.length === 0}
                        sx={{
                          ...styles.button,
                          ...{
                            height: "40px",
                            fontSize: "15px",
                            width: "150px",
                          },
                        }}
                      >
                        {isProcessing ? (
                          <CircularProgress sx={{ color: "black" }} size={25} />
                        ) : (
                          `Add Selected Folders`
                        )}
                      </Button>
                    )}
                  </Box>
                </Box>
              )}
              <FilterAndSortDetails
                filterAndSortParams={filterAndSortParams}
                setFilterAndSortParams={setFilterAndSortParams}
                setPage={setPage}
                setTracks={setTracks}
                queryValue={queryValue}
                setQueryValue={setQueryValue}
                value={value}
              />
              <FolderSection
                folders={folders}
                isLoading={isLoading}
                setOpenFoldersList={setOpenFoldersList}
                setTracks={setTracks}
                setValue={setValue}
                value={value}
                getAllFoldersForProject={getAllFoldersForProject}
                selectedFolders={selectedFolders}
                setSelectedFolders={setSelectedFolders}
                isAddFolderToProject={isAddFolderToProject}
              />
              <Box sx={{ width: "100%" }}>
                {isEnterpriseAccount && (
                  <Box>
                    <Tabs
                      TabIndicatorProps={{
                        style: { display: "none" },
                      }}
                      value={value}
                      onChange={handleChange}
                      aria-label="basic tabs example"
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                      }}
                    >
                      <Tab
                        sx={{
                          ...splitSheetStyles.tab,
                          flex: isSmallScreen ? "1 1 50%" : "",
                          background:
                            value === 0
                              ? "var(--Colors-Background-bg-active, #202425)"
                              : undefined,
                        }}
                        label="Tracks"
                        {...a11yProps(0)}
                      />
                      <Tab
                        sx={{
                          ...splitSheetStyles.tab,
                          flex: isSmallScreen ? "1 1 50%" : "",
                          background:
                            value === 1
                              ? "var(--Colors-Background-bg-active, #202425)"
                              : undefined,
                        }}
                        label="Files"
                        {...a11yProps(1)}
                      />
                      <Tab
                        sx={{
                          ...splitSheetStyles.tab,
                          flex: isSmallScreen ? "1 1 60%" : "",
                          background:
                            value === 2
                              ? "var(--Colors-Background-bg-active, #202425)"
                              : undefined,
                        }}
                        label="Completed Tracks"
                        {...a11yProps(2)}
                      />
                    </Tabs>
                  </Box>
                )}
                <CustomTabPanel value={value} index={0}>
                  <CustomTracksListContainer>
                    <TracksTableHeadings
                      filterAndSortParams={filterAndSortParams}
                      handleAscendingOrDescending={handleAscendingOrDescending}
                      isAllTracksSelected={isAllTracksSelected}
                      setCheckedTracks={setCheckedTracks}
                      tracks={tracks}
                      setIsAllTracksSelected={setIsAllTracksSelected}
                      isAddFolderToProject={isAddFolderToProject}
                    />
                    <CustomTracksScrollingContainer
                      sx={
                        isEnterpriseAccount
                          ? {
                              ...styles.bigScreenScrollC,
                              height: `calc(100vh - 280px - ${
                                folders.length === 0
                                  ? 0
                                  : folders.length < 8
                                  ? 60
                                  : 110
                              }px)`,
                            }
                          : {
                              ...styles.bigScreenScrollC,
                              height: "calc(100vh - 230px)",
                            }
                      }
                      ref={!isSmallScreen ? scrollContainerRef : null}
                    >
                      {tracks &&
                        tracks.length > 0 &&
                        tracks.map((track, i) => {
                          return (
                            <TrackListView
                              key={i}
                              index={i}
                              track={track}
                              isBoxChecked={isBoxChecked}
                              handleCheckedTrackChange={
                                handleCheckedTrackChange
                              }
                              handleRefreshTracks={handleRefreshTracks}
                              handleOpenTrackVersionModal={
                                handleOpenTrackVersionModal
                              }
                              handleOpenSelectDeleteModal={
                                handleOpenSelectDeleteModal
                              }
                              handleOpenCollabsModal={handleOpenCollabsModal}
                              handleOpenEditTrackModal={
                                handleOpenEditTrackModal
                              }
                              setIsPlayButtonClicked={setIsPlayButtonClicked}
                              trackToPlay={trackToPlay}
                              setTrackToPlay={setTrackToPlay}
                              setIsTrackForPlay={setIsTrackForPlay}
                              setVersionToPlay={setVersionToPlay}
                              setAudioDetails={setAudioDetails}
                              session={session}
                              setInbox={setInbox}
                              handleExpandTrack={handleExpandTrack}
                              expanded={trackToExpand === track.track?.getId()}
                              handleDragStart={handleDragStart}
                              handleDrop={handleDrop}
                              setDraggedIndex={setDraggedIndex}
                              isReorderAvailable={isReorderAvailable}
                              handleOpenUpdateSubModal={
                                handleOpenUpdateSubModal
                              }
                              versionToPlay={versionToPlay}
                              isAddFolderToProject={isAddFolderToProject}
                            />
                          );
                        })}
                      {tracks.length === 0 &&
                        !isLoading &&
                        !isScrollEnabled && (
                          <Box sx={styles.emptyTracksContainer}>
                            <Typography>No tracks found!</Typography>
                          </Box>
                        )}
                      {isLoading && (
                        <Box
                          ref={loadingRef}
                          sx={{
                            ...styles.loadingContainer,
                            ...{ height: isSmallScreen ? "40vh" : "auto" },
                          }}
                        >
                          <CircularProgress size={50} />
                        </Box>
                      )}
                    </CustomTracksScrollingContainer>
                  </CustomTracksListContainer>
                </CustomTabPanel>
                <CustomTabPanel value={value} index={1}>
                  <FilesSection
                    session={session}
                    setInbox={setInbox}
                    isAllFilesSelected={isAllFilesSelected}
                    setIsAllFilesSelected={setIsAllFilesSelected}
                    setCheckedFiles={setCheckedFiles}
                    isFileChecked={isFileChecked}
                    handleCheckedFileChange={handleCheckedFileChange}
                    projectQueryValue={projectQueryValue}
                    filter={filter}
                    filesSortBy={filesSortBy}
                    filesSortingIsAscending={filesSortingIsAscending}
                    setFilesSortingIsAscending={setFilesSortingIsAscending}
                    folderId={folderId}
                    foldersLength={folders.length}
                    isAddFolderToProject={isAddFolderToProject}
                  />
                </CustomTabPanel>
                <CustomTabPanel value={value} index={2}>
                  <CustomTracksListContainer>
                    <TracksTableHeadings
                      filterAndSortParams={filterAndSortParams}
                      handleAscendingOrDescending={handleAscendingOrDescending}
                      isAllTracksSelected={isAllTracksSelected}
                      setCheckedTracks={setCheckedTracks}
                      tracks={tracks}
                      setIsAllTracksSelected={setIsAllTracksSelected}
                      isAddFolderToProject={isAddFolderToProject}
                    />
                    <CustomTracksScrollingContainer
                      sx={
                        isEnterpriseAccount
                          ? {
                              ...styles.bigScreenScrollC,
                              height: `calc(100vh - 280px - ${
                                folders.length === 0
                                  ? 0
                                  : folders.length < 8
                                  ? 60
                                  : 110
                              }px)`,
                            }
                          : {
                              ...styles.bigScreenScrollC,
                              height: "calc(100vh - 230px)",
                            }
                      }
                      ref={!isSmallScreen ? scrollContainerRef : null}
                    >
                      {tracks &&
                        tracks.length > 0 &&
                        tracks.map((track, i) => {
                          return (
                            <TrackListView
                              key={i}
                              index={i}
                              track={track}
                              isBoxChecked={isBoxChecked}
                              handleCheckedTrackChange={
                                handleCheckedTrackChange
                              }
                              handleRefreshTracks={handleRefreshTracks}
                              handleOpenTrackVersionModal={
                                handleOpenTrackVersionModal
                              }
                              handleOpenSelectDeleteModal={
                                handleOpenSelectDeleteModal
                              }
                              handleOpenCollabsModal={handleOpenCollabsModal}
                              handleOpenEditTrackModal={
                                handleOpenEditTrackModal
                              }
                              setIsPlayButtonClicked={setIsPlayButtonClicked}
                              trackToPlay={trackToPlay}
                              setTrackToPlay={setTrackToPlay}
                              setIsTrackForPlay={setIsTrackForPlay}
                              setVersionToPlay={setVersionToPlay}
                              setAudioDetails={setAudioDetails}
                              session={session}
                              setInbox={setInbox}
                              handleExpandTrack={handleExpandTrack}
                              expanded={trackToExpand === track.track?.getId()}
                              handleDragStart={handleDragStart}
                              handleDrop={handleDrop}
                              setDraggedIndex={setDraggedIndex}
                              isReorderAvailable={isReorderAvailable}
                              handleOpenUpdateSubModal={
                                handleOpenUpdateSubModal
                              }
                              versionToPlay={versionToPlay}
                              isAddFolderToProject={isAddFolderToProject}
                            />
                          );
                        })}
                      {tracks.length === 0 &&
                        !isLoading &&
                        !isScrollEnabled && (
                          <Box sx={styles.emptyTracksContainer}>
                            <Typography>No tracks found!</Typography>
                          </Box>
                        )}
                      {isLoading && (
                        <Box
                          ref={loadingRef}
                          sx={{
                            ...styles.loadingContainer,
                            ...{ height: isSmallScreen ? "40vh" : "auto" },
                          }}
                        >
                          <CircularProgress size={50} />
                        </Box>
                      )}
                    </CustomTracksScrollingContainer>
                  </CustomTracksListContainer>
                </CustomTabPanel>
              </Box>
            </Box>
          </Box>
        </TracksPageMainContainer>
      </Box>
      <Box sx={{ display: "none" }} ref={ref} />
      <MobileScreenBottomNavigationContainer>
        <MobileScreenBottomNavigation />
      </MobileScreenBottomNavigationContainer>
      <AudioPlayer
        trackToPlay={trackToPlay}
        isPlayButtonClicked={isPlayButtonClicked}
        setIsPlayButtonClicked={setIsPlayButtonClicked}
        versionToPlay={versionToPlay}
        audioDetails={audioDetails}
        isTrackForPlay={isTrackForPlay}
        setTrackToPlay={setTrackToPlay}
        setVersionToPlay={setVersionToPlay}
      />
    </>
  );
};
